import { forwardRef } from "react";
import { Box, BoxProps } from "./Box";

export const FlexColBox = forwardRef((props: BoxProps, ref) => {
  return <Box display="flex" flexDirection="column" {...props} ref={ref} />;
});
